import { render, staticRenderFns } from "./MassPendingLink.vue?vue&type=template&id=39d2f16e&"
import script from "./MassPendingLink.vue?vue&type=script&lang=js&"
export * from "./MassPendingLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports